import React, { useState } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import { Link } from 'react-router-dom';

import t from '@guestyci/localize/t.macro';

import Avatar from 'components/common/Avatar';

const NavbarAvatar = ({ src, name, onLogout }) => {
  const [openState, setOpenState] = useState(false);

  const onClick = () => {
    setOpenState(!openState);
  };

  const onHide = () => {
    setOpenState(false);
  };

  return (
    <Popover
      containerStyle={{ background: 'transparent', zIndex: 9999 }}
      reposition={false}
      isOpen={openState}
      onClickOutside={onHide}
      positions={['bottom']}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowSize={10}
          arrowStyle={{ top: '20px' }}
        >
          <ul
            style={{
              background: 'white',
              boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.1)',
            }}
            className="menu"
          >
            <li className="menu-item">
              <Link to="/my-profile">{t('My profile')}</Link>
            </li>
            <li className="menu-item">
              <span aria-hidden="true" onClick={onLogout}>
                {t('Log out')}
              </span>
            </li>
          </ul>
        </ArrowContainer>
      )}
    >
      <Avatar src={src} name={name} onClick={onClick}>
        <div className="stretch" style={{ bottom: -3 }} />
      </Avatar>
    </Popover>
  );
};

export default NavbarAvatar;
